module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i3cbB"))).then(() => module.bundle.root('1iHdE'));